import React from 'react'
import hotelLocationPagesDE from '../../../../config/hotelLocationPagesDE'
import ProductSelect from './productSelect.jsx'

const HotelSelect = ({id, label = 'Bitte wählen Sie Ihr Flughafen-Hotel aus'}) => (
  <ProductSelect id={id} label={label} options={hotelLocationPagesDE} />
)

export default HotelSelect



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/dropdowns/hotelselectDE.jsx